import styled from "styled-components";
import { elRed, headerGray } from "src/styles/colors";
import fonts from "src/styles/fonts";

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  background-color: ${headerGray};
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const RightColumn = styled.div`

`

export const DotGrid = styled.div`


`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12%;
  margin-top: 10px;
`;

export const RedSeparator = styled.div`
  width: 30%;
  max-width: 75px;
  height: 10px;
  border-radius: 5px;
  background-color: ${elRed};
  margin-top: -20px;
  margin-bottom: 40px;
`;

export const RegularText = styled.div`
  max-width: 100%;
  margin-right: 20px;
`;

export const SectionHeader = styled.h2`
  font-size: 32px;
  margin: 0 0 25px;
`;

export const HeaderLabel = styled.h1`
  font-size: ${fonts.pageTitle.mobileSize};
  font-weight: ${fonts.pageTitle.weight};

  @media (min-width: 768px) {
    font-size: ${fonts.pageTitle.size};
    width: 100%;
  }
`;

export const ImageContainer = styled.div`

  @media(min-width: 768px) {
    width: 50%;
    float: right;
    position: relative;
  }
`;